module.exports = __webpack_public_path__ + "static/img/logo1.fca941e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solutions/logo1.png
// module id = NGxY
// module chunks = 0